import { makeStyles } from '@material-ui/core/styles';
import { Modal, Backdrop, Fade } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: (props) => props.customBackgroundColor || theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    outline: 'none',
    padding: theme.spacing(2, 4, 3),
  },
  paperWithoutPadding: {
    padding: 0,
  },
}));

const CommonModal = (props) => {
  const { customBackgroundColor, classStyle, removePadding, isOpen, setIsOpen, children } = props;
  const classes = useStyles({ customBackgroundColor });

  const handleClose = () => {
    setIsOpen(false);
    if (props.callback) {
      props.callback();
    }
  };

  const handleBackdropClick = (event) => {
    if (event.target === event.currentTarget) {
      handleClose();
    }
  };

  const paperClassName = removePadding
    ? `${classes.paper} ${classes.paperWithoutPadding}`
    : classes.paper;

  return (
    <Modal
      className={props?.modalClass ?? classes.modal}
      open={isOpen}
      onClose={handleClose}
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
        onClick: handleBackdropClick,
      }}
    >
      <Fade in={isOpen}>
        <div className={`${paperClassName} ${classStyle}`}>{children}</div>
      </Fade>
    </Modal>
  );
};

export default CommonModal;